/** When your routing table is too long, you can split it into small modules **/

export default {
  path: '/home',
  name: 'home',
  alwaysShow: true,
  redirect: '/dashboard',
  component: () => import(/* webpackChunkName: 'nested' */ '@/layout/Layout'),
  meta: {
    title: 'resource.txt.home',
    icon: 'el-icon-s-home',
    order: 100
  },
  //ホーム画面
  children: [
    {
      path: '/dashboard',
      component: () => import('@/views/home/Home'),
      name: 'Dashboard',
      hidden: true,
      meta: {
        order: 101,
        title: 'resource.txt.home',
        activeMenu: '/home',
        icon: 'el-icon-s-home'
      }
    }
  ]
}
